import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Icon from 'components/Icon';

import Container from './UnsavedChanges.styled';

const UnsavedChanges = ({ changes, exit, stay, save }) => (
  <Container className="absolute-inset">
    <div className="box">
      <Button type="button" className="close-button" onClick={stay}>
        <Icon name="close" />
      </Button>
      <p>
        {`You have ${changes} unsaved ${changes === 1 ? 'change' : 'changes'}`}
        <br />
        Are you sure want to exit?
      </p>
      <Button type="button" className="action-button" onClick={save} styled>
        Save and exit
      </Button>
      <Button
        type="button"
        className="action-button"
        onClick={exit}
        styled
        grey
        style={{ marginLeft: 15 }}>
        Exit without saving
      </Button>
    </div>
  </Container>
);

UnsavedChanges.propTypes = {
  changes: PropTypes.number.isRequired,
  exit: PropTypes.func.isRequired,
  stay: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
};

export default UnsavedChanges;
